import { AppConfig } from '@dh-io-emh/config-types';
import User from '../models/user.model';
import { createHttpService } from '../utils/http.util';
import { SMSAddress, SMSAddressList, SMSUser } from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';

export type UserApi = ReturnType<typeof createUserApi>;

export const createUserApi = ({ config: { apiBaseUrl, lang, siteId } }: { config: AppConfig }) => {
  const http = createHttpService({
    url: `${apiBaseUrl}/v2/${siteId}`,
    params: { lang },
  });

  return {
    /**
     * Gets the cart data for the authenticated user.
     *
     * @param {string} userId
     * @returns {Promise}
     */
    getUser: (userId: string) =>
      http
        .get<Required<SMSUser>>(`users/${userId}`, {
          params: {
            fields: 'FULL',
          },
        })
        .then((res) => User.create(res.data)),

    getUserPaymentAddress: async (userId: string): Promise<SMSAddress | null> => {
      const { data } = await http.get<SMSAddressList>(`users/${userId}/addresses/payment`, {
        params: {
          fields: 'FULL',
        },
      });

      if (data.addresses && data.addresses.length) {
        return data.addresses[data.addresses.length - 1];
      }

      return null;
    },

    getUserContactAddress: async (userId: string): Promise<SMSAddress | null> => {
      const { data } = await http.get<SMSAddress>(`users/${userId}/addresses/contact`, {
        params: {
          fields: 'FULL',
        },
      });

      return data;
    },

    postUserAddress: async (userId: string, newUserAddress: SMSAddress): Promise<SMSAddress> => {
      const { data } = await http.post<SMSAddress>(`users/${userId}/addresses`, {
        data: newUserAddress,
      });

      return data;
    },

    putUserAddress: async (userId: string, modifiedUserAddress: SMSAddress): Promise<void> => {
      await http.put<void>(`users/${userId}/addresses/${modifiedUserAddress.id}`, {
        data: modifiedUserAddress,
      });
    },
  };
};
